import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Button } from "antd";
import '../../styles/registration.css';
import { AuthPageContainer } from './AuthPageContainer';
import { AuthInput } from './AuthInput';
import { isValid } from '../../utils/Validation'
import { ErrorHandler } from '../Errors/ErrorHandler';

export const Register = () => {
    const { id } = useParams();

    const [userToSend, setUserToSend] = useState(null);
    const [userName, setUserName] = useState("");
    const [firstName, setFirstName] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [password, setPassword] = useState(null);
    const [verifyPassword, setVerifyPassword] = useState(null);
    const [redirectUrl, setRedirectUrl] = useState(null);

    const [subHeader, setSubHeader] = useState("יש למלא את כל השדות");

    const [status, setStatus] = useState(200);
    const [disabled, setDisabled] = useState(false);

    const submitSignUp = async (signUpFromData) => {
        if (disabled) {
            return;
        }

        setDisabled(true);
        //@ts-ignore
        if (userToSend) {
            const clonedUserToSend = userToSend;
            clonedUserToSend.username = signUpFromData.username;
            clonedUserToSend.firstname = signUpFromData.firstname;
            clonedUserToSend.lastname = signUpFromData.lastname;
            clonedUserToSend.phoneNumber = signUpFromData.phoneNumber;
            clonedUserToSend.newPassword = signUpFromData.password;
            const result = await sendInvitation(id, clonedUserToSend);
            const { error } = result;

            if (error) {
                return error;
            }

            if (redirectUrl) {
                window.location.href = redirectUrl;
            }
        }
        setDisabled(false);
    };

    const getUserDetails = useCallback(async () => {
        const result = await getInvitation();
        setStatus(result.status);
        if (result.status === 200) {
            // @ts-ignore
            setUserToSend(result.data);
            // @ts-ignore
            setUserName(result.data.username);
            setPhoneNumber(result.data.phoneNumber);
            setRedirectUrl(result.data.redirectUrl);
        }
    }, [id]);

    useEffect(() => {
        id && getUserDetails()
    }, [id]);

    useEffect(() => {
        if (firstName && firstName.length && lastName && lastName.length && phoneNumber && phoneNumber.length &&
            password && password.length && verifyPassword && verifyPassword.length) {
            setSubHeader(null);
        } else {
            setSubHeader("יש למלא את כל השדות");
        }

        setDisabled(isDisabled())
    }, [firstName, lastName, phoneNumber, password, verifyPassword]);

    function isDisabled() {
        return password !== verifyPassword || isValid(password ?? "", "password", true) !== "" || firstName === '' || lastName === '' || phoneNumber === '' || firstName === null || lastName === null || phoneNumber === null ||
            isValid(firstName ?? "", "firstName", firstName !== null) !== "" ||
            isValid(lastName ?? "", "lastName", lastName !== null) !== "" ||
            isValid(phoneNumber ?? "", "cellPhone", phoneNumber !== null) !== ""
    }

    const getInvitation = async () => {
        return await axios.get(`/registration/get?invitationID=${id}`);
    };

    const sendInvitation = async (pid, user) => {
        return await axios.post(`/registration/acceptinvitation?invitationID=${pid}`, { ...user });
    }

    const isUserNameReadOnly = () => {
        return userToSend.username && userToSend.username.length > 0;
    }

    return (
        userToSend && status == 200 ?
            <AuthPageContainer
                header={"להגדרת החשבון שלך"}
                subHeader={subHeader}
                subHeaderStyle={{ color: "#DD1C1C", marginBottom: "16px" }}>
                <AuthInput
                    baseInputFieldType={userName}
                    errors={false}
                    label={"שם משתמש"}
                    value={userName}
                    readOnly={isUserNameReadOnly()}
                    onChange={setUserName}
                    helperText={
                        {
                            message: "הסיסמה לא תואמת למדיניות הסיסמאות",
                            type: "string"
                        }
                    }
                    isPasswordPopper={false}
                    icon={svgObject.user}
                    required={true}
                />

                <AuthInput
                    baseInputFieldType={"firstName"}
                    errors={isValid(firstName ?? "", "firstName", firstName !== null) !== ""}
                    label={"שם פרטי"}
                    value={firstName}
                    readOnly={false}
                    onChange={setFirstName}
                    helperText={
                        {
                            message: isValid(firstName ?? "", "firstName", firstName !== null),
                            type: "string"
                        }
                    }
                    isPasswordPopper={false}
                    icon={svgObject.user}
                    required={true}
                />

                <AuthInput
                    baseInputFieldType={"lastName"}
                    errors={isValid(lastName ?? "", "lastName", lastName !== null) !== ""}
                    label={"שם משפחה"}
                    value={lastName}
                    readOnly={false}
                    onChange={setLastName}
                    helperText={
                        {
                            message: isValid(lastName ?? "", "lastName", lastName !== null),
                            type: "string"
                        }
                    }
                    isPasswordPopper={false}
                    icon={svgObject.user}
                    required={true}
                />

                <AuthInput
                    baseInputFieldType={"phoneNumber"}
                    errors={isValid(phoneNumber ?? "", "cellPhone", phoneNumber !== null) !== ""}
                    label={"טלפון נייד"}
                    value={phoneNumber}
                    readOnly={false}
                    onChange={setPhoneNumber}
                    helperText={
                        {
                            message: isValid(phoneNumber ?? "", "cellPhone", phoneNumber !== null),
                            type: "string"
                        }
                    }
                    isPasswordPopper={false}
                    icon={svgObject.phone}
                    required={true}
                />

                <AuthInput
                    userName={userName}
                    baseInputFieldType={"password"}
                    errors={isValid(password ?? "", "password", password !== null) !== ""}
                    label={"סיסמה"}
                    value={password}
                    readOnly={false}
                    onChange={setPassword}
                    helperText={
                        {
                            message: "הסיסמה לא תואמת למדיניות הסיסמאות",
                            type: "string"
                        }
                    }
                    isPasswordPopper={true}
                    icon={svgObject.password}
                    required={true}
                />

                <AuthInput
                    userName={userName}
                    baseInputFieldType={"password"}
                    errors={password !== verifyPassword}
                    label={"אימות סיסמה"}
                    value={verifyPassword}
                    readOnly={false}
                    onChange={setVerifyPassword}
                    helperText={
                        {
                            message: "סיסמאות לא תואמות",
                            type: "string"
                        }
                    }
                    isPasswordPopper={false}
                    icon={svgObject.password}
                    required={true}
                />

                <Button
                    type="primary"
                    disabled={disabled}
                    htmlType="submit"
                    className={"buttonConfrim"}
                    onClick={() => submitSignUp({ username: userName, password, verifyPassword, firstname: firstName, lastname: lastName, phoneNumber })}
                >
                    {"אישור"}
                </Button>
            </AuthPageContainer> :
            <ErrorHandler status={status} />
    );
};

const svgObject = {
    user: <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_4497_21493)">
            <path
                d="M3 3C3 2.40666 3.17595 1.82664 3.50559 1.33329C3.83524 0.839943 4.30377 0.455426 4.85195 0.228363C5.40013 0.00129987 6.00333 -0.0581101 6.58527 0.0576455C7.16721 0.173401 7.70176 0.459123 8.12132 0.878681C8.54088 1.29824 8.8266 1.83279 8.94236 2.41473C9.05811 2.99667 8.9987 3.59987 8.77164 4.14805C8.54458 4.69623 8.16006 5.16476 7.66671 5.49441C7.17336 5.82405 6.59334 6 6 6C5.20459 5.99921 4.44199 5.68288 3.87956 5.12044C3.31712 4.55801 3.00079 3.79541 3 3ZM6 7C4.80693 7.00132 3.66311 7.47585 2.81948 8.31948C1.97585 9.16311 1.50132 10.3069 1.5 11.5C1.5 11.6326 1.55268 11.7598 1.64645 11.8536C1.74021 11.9473 1.86739 12 2 12H10C10.1326 12 10.2598 11.9473 10.3536 11.8536C10.4473 11.7598 10.5 11.6326 10.5 11.5C10.4987 10.3069 10.0241 9.16311 9.18052 8.31948C8.33689 7.47585 7.19307 7.00132 6 7Z"
                fill="#73767D"
            />
        </g>
        <defs>
            <clipPath id="clip0_4497_21493">
                <rect width="12" height="12" fill="white" />
            </clipPath>
        </defs>
    </svg>,
    phone: <svg
        width="13"
        height="12"
        viewBox="0 0 13 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.3229 7.44223C11.0337 7.16703 10.6496 7.0138 10.2503 7.01436C9.8511 7.01492 9.46741 7.16922 9.17895 7.44523L8.22417 8.24973C7.44485 7.92723 6.73691 7.45397 6.14101 6.85712C5.5451 6.26027 5.07296 5.55158 4.7517 4.77176L5.55319 3.81999C5.82847 3.53095 5.98227 3.14725 5.98283 2.74809C5.98339 2.34894 5.83067 1.96481 5.5562 1.675C5.5562 1.675 4.62847 0.471257 4.61294 0.455728C4.32713 0.168067 3.93963 0.00439903 3.53414 8.7387e-05C3.12866 -0.00422425 2.73776 0.151166 2.4459 0.432685L1.86983 0.933617C-1.99688 5.04627 7.98122 15.0288 12.0889 11.1025L12.5457 10.5766C12.8359 10.2855 12.9988 9.89126 12.9988 9.48027C12.9988 9.06928 12.8359 8.67506 12.5457 8.38398C12.5292 8.37045 11.3229 7.44223 11.3229 7.44223Z"
            fill="#73767D"
        />
    </svg>,
    password: <svg
        width="10"
        height="12"
        viewBox="0 0 10 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8.49999 4.212V3.49999C8.49999 1.56701 6.93301 0 5 0C3.06699 0 1.5 1.56701 1.5 3.49999V4.212C0.590016 4.60915 0.0013125 5.50713 0 6.49999V9.49999C0.00164063 10.88 1.11996 11.9984 2.49999 12H7.49998C8.88001 11.9984 9.99833 10.88 9.99999 9.49999V6.49999C9.9987 5.50713 9.40998 4.60915 8.49999 4.212ZM5.49999 8.50001C5.49999 8.77615 5.27614 9 5 9C4.72386 9 4.5 8.77615 4.5 8.50001V7.5C4.5 7.22386 4.72386 7.00001 5 7.00001C5.27614 7.00001 5.49999 7.22386 5.49999 7.5V8.50001ZM7.50001 4.00001H2.49999V3.50002C2.49999 2.11931 3.61927 1.00001 5 1.00001C6.38072 1.00001 7.50001 2.11929 7.50001 3.50002V4.00001Z"
            fill="#73767D"
        />
    </svg>
}